import React from 'react';
import { connect } from 'react-redux';
import {
  getPrimaryPrice,
  getProductPriceCategory,
  getSecondPrice,
  isWebSellable,
} from 'features/product-info/ducks/selectors';
import { getGoodsSupplyCase } from 'features/goods-supply/selectors';
import { RootReducer } from 'store/root-reducer';
import { PriceMainProps } from 'common/components/product-price-view/types';
import { getLocale } from 'utils';
import { PriceViewMappedState, PriceViewProps } from './types';
import { isValues, setProps } from './utils';
import { APriceView } from './a-price-view';
import { FirstPriceView } from './components';

export const PriceView: React.FC<
  PriceViewProps & { isStickyPanel: boolean; secondPriceClassName?: string; oldNewPriceClassName?: string }
> = ({
  className = '',
  secondPriceClassName = className,
  firstPrice,
  secondPrice,
  isSellable,
  supplyCase,
  productPriceCategory,
  oldNewPriceClassName,
  isStickyPanel,
  ...htmlProps
}) => {
  let content: React.ReactNode = null;
  const isBestPrice = productPriceCategory === 'bestPrice';
  const hasThreePrices = !!firstPrice.prevPrice && !!secondPrice.price;
  const locale = getLocale();

  if (isSellable) {
    content = (
      <>
        <FirstPriceView
          price={firstPrice}
          oldNewPriceClassName={oldNewPriceClassName}
          className={className}
          isBestPrice={isBestPrice}
          hasThreePrices={hasThreePrices}
          isStickyPanel={isStickyPanel}
          {...htmlProps}
        />
        {isValues(secondPrice) ? (
          <APriceView
            hasThreePrices={hasThreePrices}
            isStickyPanel={isStickyPanel}
            className={secondPriceClassName}
            name="second"
            {...setProps({ ...secondPrice, locale })}
            {...htmlProps}
          />
        ) : null}
      </>
    );

    if (supplyCase !== null && ['CASE_1', 'CASE_5'].includes(supplyCase)) {
      content = null;
    }
  }

  return <>{content}</>;
};

export const mapStoreToProps = (store: RootReducer): PriceViewMappedState => {
  const firstPrice = getPrimaryPrice(store) as PriceMainProps;
  const secondPrice = getSecondPrice(store) as PriceMainProps;
  const isSellable = isWebSellable(store);
  const supplyCase = getGoodsSupplyCase(store);
  const productPriceCategory = getProductPriceCategory(store) ?? '';
  return {
    firstPrice,
    secondPrice,
    isSellable,
    supplyCase,
    productPriceCategory,
  };
};

export const PdpPriceView = connect(mapStoreToProps, null, (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...ownProps,
}))(PriceView);
